export interface LibrarySort {
	field: string;
	order: number;
}
